<template>
  <q-fila v-if="aplica" :label="label" :ayuda="ayuda" :completa="respondida" :resaltar="resaltar">
    <div class="d-flex flex-wrap sheet-opciones-grupo" role="group">
      <button type="button" class="btn btn-sheet-opcion mb-1" :class="[valor === true ? claseSi : 'btn-outline-secondary']"
              :disabled="soloLectura" @click.prevent="marcar(true)">SI</button>
      <button type="button" class="btn btn-sheet-opcion mb-1" :class="[valor === false ? claseNo : 'btn-outline-secondary']"
              :disabled="soloLectura" @click.prevent="marcar(false)">NO</button>
    </div>
    <slot name="dependiente"></slot>
  </q-fila>
</template>

<script>
import QFila from "./QFila";

/**
 * Pregunta SI / NO. `null` = sin responder, que no es lo mismo que responder NO.
 *
 * `incidencia` invierte el color: en las preguntas sobre hechos negativos, el SI
 * se pinta en rojo, como en las fichas anteriores.
 */
export default {
  name: "QSiNo",
  components: { QFila },
  props: {
    value: { default: null },
    label: { type: String, required: true },
    ayuda: { type: String, default: "" },
    aplica: { type: Boolean, default: true },
    resaltar: { type: Boolean, default: true },
    soloLectura: { type: Boolean, default: false },
    incidencia: { type: Boolean, default: false },
  },
  computed: {
    valor() {
      return this.value;
    },
    respondida() {
      return this.value === true || this.value === false;
    },
    claseSi() {
      return this.incidencia ? "btn-danger" : "btn-success";
    },
    claseNo() {
      return this.incidencia ? "btn-success" : "btn-danger";
    },
  },
  methods: {
    marcar(v) {
      if (this.soloLectura) return;
      // volver a pulsar la opción marcada la deja sin responder
      const nuevo = this.value === v ? null : v;
      this.$emit("input", nuevo);
      this.$emit("cambio", nuevo);
    },
  },
};
</script>
